import { decorate, observable, action, computed } from 'mobx';
import BaseStore from '../BaseStore';
import { dayFieldSorter, quarterYearFieldSorter } from './components/DateOptions';

class ViewAggregationStore extends BaseStore {
  data = []
  column = {}
  groupByColumns = [
    {},
  ]
  columns = []
  isLoading = false
  type = "count"
  baseGrid = Ext.create("TL.list.BaseGrid")
  isExtjsDelayedRender = true


  getDefaultAggregationColumn = () => {
    let me = this,
      column = {
        aggregation_type: "count",
        alias_path: 'COUNT( row_id )',
        unique_dom_id: Util.getUniqueId(),
        is_loading: true
        // aggregation_value: 0,
      };
    // if (this.currentViewCount !== undefined) {
    // column.aggregation_value = this.currentViewCount
    // column.is_loading = false;
    // }
    return column
  }

  viewAggregationColumns = [
    this.getDefaultAggregationColumn()
  ]

  constructor(appStore) {
    super(appStore);
  }


  handleClick = event => {
    this.anchorEl = document.body
    this.isExtjsDelayedRender = true
  };

  handleClose = () => {
    this.anchorEl = null;
  };

  setViewAggregationData = (columns, listConfig, listId, view) => {
    this.columns = columns;
    this.listConfig = {
        color_codes: listConfig.colorCodes,
        list: listConfig.list,
        list_columns: listConfig.listData,
        list_permissions: listConfig.listPermissions
    }
    this.listId = listId;
    this.viewConfig = view;
  }

  handleAddButtonClick = () => {
    let me = this;

    me.groupByColumns = [...me.groupByColumns, {}];
  }

  handleGroupByColumnDelete = (key) => {
    let me = this,
      groupByColumns = [...me.groupByColumns];

    groupByColumns.splice(key, 1);
    me.groupByColumns = groupByColumns;
    if (me.groupByColumns.length == 0) {
      me.groupByColumns = [{}];
    }
    me.fetchData();
  }

  handleAddViewAggregationColumn = () => {
    let me = this;

    me.viewAggregationColumns = [...me.viewAggregationColumns, me.getDefaultAggregationColumn(),
    ];
  }

  handleViewAggregationColumnChange = (column, key) => {
    Object.keys(column).forEach(objectKey => {
      this.viewAggregationColumns[key][objectKey] = column[objectKey];
    })

    // this.viewAggregationColumns[key] = this.viewAggregationColumns[key];
    this.fetchData();
  }

  handleViewAggregationColumnValueChange = (value, key) => {
    if (!this.viewAggregationColumns[key]) {
      return;
    }
    if (this.viewAggregationColumns[key]['aggregation_type'] == "count") {
      this.currentViewCount = value;
    }
    this.viewAggregationColumns[key]['aggregation_value'] = value;
    this.viewAggregationColumns[key]['is_loading'] = false;

  }

  handleDeleteViewAggregationColumn = (key) => {
    let me = this,
      viewAggregationColumns = [...me.viewAggregationColumns];

    viewAggregationColumns.splice(key, 1);
    me.viewAggregationColumns = viewAggregationColumns;
    if (me.viewAggregationColumns.length == 0) {
      me.viewAggregationColumns = [me.getDefaultAggregationColumn()];
    }

    me.fetchData();
  }

  handleGroupByColumnChange(column, key) {
    let me = this,
      limit;

    column['group_by_options'] = column['group_by_options'] || {};
    if (key == 0) {
      limit = me.groupByColumns[key]['group_by_options'] && me.groupByColumns[key]['group_by_options']['limit'] ? me.groupByColumns[key]['group_by_options']['limit'] : 10;

      column['group_by_options']['limit'] = limit;
    }

    if (column.column_type_id == 4 || column.column_type_id == 16) {
      column['group_by_options'] = {
        ...column['group_by_options'],
        format: { value: 'month-year' },
        value: {}
      }
    }

    me.groupByColumns[key] = column
    me.fetchData();
  }

  handleGroupByColumnLimitChange(limit, key) {
    let me = this,
      column = me.groupByColumns[key];

    me.groupByColumns.forEach(col => {
      if (col.group_by_options && col.group_by_options.limit) {
        delete col.group_by_options.limit;
      }
    })

    column['group_by_options'] = column['group_by_options'] || {};
    column['group_by_options'] = { ...column['group_by_options'], limit };
    me.groupByColumns[key] = column

    me.fetchData();
  }

  handleGroupByColumnOptionsChange(value, key) {
    let me = this,
      column = me.groupByColumns[key];
    column['group_by_options'] = value
    me.groupByColumns[key] = { ...column }

    if (value.format.value == "month-year" || value.format.value == "day" || value.format.value == "date" || value.value.value) {
      me.fetchData();
    }
    // me.fetchData();
  }

  getCriteria(column, value) {
    let criteria,
      columnAliasPath = column.alias_path;

    if (column.column_type_id == 4 || column.column_type_id == 16) {
      let groupByOptions = column['group_by_options'] || {
        format: {},
        value: {}
      }
      switch (groupByOptions['format']['value']) {
        case "day":
          columnAliasPath = `DAYNAME(${columnAliasPath})`;
          break;
        case "quarter-year":
          if (groupByOptions['value']['value']) {
            let month = groupByOptions['value']['value'] - 1;
            columnAliasPath = `CONCAT('Q', QUARTER(${columnAliasPath} - INTERVAL $month MONTH), ' ', YEAR(${columnAliasPath} - INTERVAL $month MONTH))`;
            break;
          }

          columnAliasPath = `QUARTER(${columnAliasPath})`;
          break;
        case "year":
          if (groupByOptions['value']['value']) {
            let month = groupByOptions['value']['value'] - 1;
            columnAliasPath = `YEAR(${columnAliasPath} - INTERVAL $month MONTH)`;
            break;
          }

          columnAliasPath = `YEAR(${columnAliasPath})`;
          break;
        case "date":
          columnAliasPath = `DATE(${columnAliasPath})`
          break;
        case "month-year":
        default:
          columnAliasPath = `CONCAT( MONTHNAME(${columnAliasPath}), ' ',  YEAR(${columnAliasPath}))`;
      }
    }

    criteria = `${columnAliasPath} = '${value}'`;
    return criteria;
  }

  setData(data) {
    let me = this;
    super.setData(...arguments);


    if (data.viewConfig) {
      me.viewAggregationColumns = me.viewAggregationColumns.map((col) => {
        col.unique_dom_id = Util.getUniqueId()
        delete col.aggregation_value;
        col.is_loading = true;
        return col;
      });
    }

    if (data.aggregationColumn) {
      me.viewAggregationColumns = [{
        ...data.aggregationColumn,
        unique_dom_id: Util.getUniqueId(),
      }];
    }

    this.fetchData();
  }

  refreshData() {
    const me = this;

    me.viewAggregationColumns = [...me.viewAggregationColumns].map(col => {
      delete col.aggregation_value;
      return { ...col, unique_dom_id: Util.getUniqueId(), is_loading: true }
    });
    me.fetchData();
  }

  fetchData() {
    let me = this,
      response, groupByColumns;

    me.data = [];

    groupByColumns = me.groupByColumns.filter(col => col.alias_path);
    if (!groupByColumns[0]) {
      return;
    }

    if (me.currentAjaxRequest) {
      me.currentAjaxRequest.cancelAjaxRequest();
    }
    me.isLoading = true;
    response = window.TL.ApiClient.Views.getRunViewAggregationData({
      list_id: me.listId,
      column_alias_path: me.columnAliasPath,
      column_data_index: me.columnDataIndex,
      type: me.type,
      view: JSON.stringify(me.viewConfig),
      aggregation_columns: JSON.stringify(me.viewAggregationColumns),
      group_by: JSON.stringify(groupByColumns)
    });

    me.currentAjaxRequest = response;
    response.then({
      success: function (response) {
        me.isLoading = false;
        let data = response.data;

        if (response.success) {
          me.groupByColumns = response.data.columns.group_by // overriding for dataIndex
          me.viewAggregationColumns = response.data.columns.aggregation.map((col, key) => {
            if (!col) {
              return false;
            }
            col.aggregation_value = me.viewAggregationColumns[key]['aggregation_value']
            col.is_loading = false;
            return col;
          });

          me.data = response.data.data;
          me.totalCount = response.data.total_count;
        } else {
          Ext.Msg.alert('Error', response.message)
        }
      },
      failure: function (response) {
        me.isLoading = false;
        if (response.statusText == "transaction aborted") {
          return;
        }
        Ext.Msg.alert('Error', 'Something went wrong. Please try again.')
      }
    });
  }

  get tableColumns() {
    let me = this,
      columns,
      aggregationColumns;

    columns = me.groupByColumns.filter(col => col.dataIndex);
    columns = columns.map(col => {
      let data = {
        Header: col.alias_path,
        accessor: col.dataIndex,
        id: col.unique_dom_id,
        raw: col,
        Cell: (e) => {
          let row = e.row;

          if ((col.column_type_id == 4 || col.column_type_id == 16) && col.group_by_options && col.group_by_options.format.value != "date") {
            return row.values[col.dataIndex] || "_blanks";
          }

          if (col.column_type_id == 16) {
            col.options = Ext.decode(col.options);
            if (col.options[0].format) {
              col.options[0].format = col.options[0].format.replace(" g:iA", "")
            }
          }
          return me.baseGrid.formatData(col, true)(row.values[col.dataIndex]) || "_blanks"
        },
        isCellClick: true,
      }

      if (col.column_type_id == 4 || col.column_type_id == 16) {
        data.sortType = (a, b) => {
          a = a.original[col.dataIndex];
          b = b.original[col.dataIndex];

          if (a == b) {
            return 0;
          }

          switch (col['group_by_options']['format']['value']) {
            case "month-year":
            case "year":
              a = new Date(a);
              b = new Date(b);
              break;

            case "day":
              return dayFieldSorter(a, b)

            case "quarter-year":
              return quarterYearFieldSorter(a, b);

          }
          return a > b ? 1 : -1
        }
      }
      return data;
    });

    aggregationColumns = me.viewAggregationColumns.filter(col => col.dataIndex);
    aggregationColumns = aggregationColumns.map(col => {
      let aggregationColumnAliasPath = col.aggregation_type == "count" ? "Id" : col.alias_path,
        header = col.aggregation_type != "expression"
          ? col.aggregation_type.toUpperCase() + "( " + aggregationColumnAliasPath + " )"
          : col.alias_path,
        dataIndex = col.dataIndex;

      return {
        Header: header,
        accessor: dataIndex,
        filter: 'between',
        // id: col.unique_dom_id,
        Cell: (e) => {
          let row = e.row,
            value = row.values[dataIndex];

          return col.aggregation_type == "count_distinct" || col.aggregation_type == "count" || col.view_column_type == "aggregate"
            ? (value - - 0).toLocaleString('En')
            : me.baseGrid.formatData(col, true)(value)
        }
      }
    })

    return columns.concat(aggregationColumns);
  }

}

decorate(ViewAggregationStore, {
  anchorEl: observable,
  data: observable,
  column: observable,
  groupByColumns: observable,
  viewAggregationColumns: observable,
  isLoading: observable,
  totalCount: observable,

  tableColumns: computed
});

export default ViewAggregationStore;